import React, { Component } from "react";
import Table from "../Table";
import { Link } from "react-router-dom";
import moment from "moment";

import DataTable from "react-data-table-component";

class ApplicationsTable extends Component {
  state = {
    cobrand: this.props.cobrand,
    data: [],
    rowsPerPage: 10
  };

  render() {
    const title = "Applications";
    const columns = [
      {
        name: "Login Name",
        selector: "user.loginName",
        sortable: true,
        ignoreRowClick: true,
        cell: row => {
          return <span title={row.user.loginName}>{row.user.loginName}</span>;
        }
      },
      {
        name: "Application ID",
        selector: "id",
        sortable: true,
        ignoreRowClick: true,
        cell: row => {
          return (
            <React.Fragment>
              <Link
                to={{
                  pathname:
                    "/applications/" + this.props.cobrand.id + "/" + row.id,
                  state: [
                    ...this.props.data.filter(cobrand => cobrand.id === row.id)
                  ]
                }}
              >
                {row.id}
              </Link>
            </React.Fragment>
          );
        }
      },
      {
        name: "Status",
        selector: "status",
        sortable: true,
        ignoreRowClick: true,
        maxWidth: "20%"
      },
      {
        name: "Last Updated",
        selector: "submissionDate",
        sortable: true,
        ignoreRowClick: true,
        maxWidth: "15%",
        cell: row => {
          return (
            <span>
              {moment
                .utc(row.completionDate)
                .local()
                .format("MM-DD-YYYY HH:mm")}
            </span>
          );
        }
      }
    ];
    return (
      <DataTable
        title={title}
        columns={columns}
        data={this.props.data}
        responsive
        pagination
        paginationServer
        paginationRowsPerPageOptions={[25, 50, 75, 100]}
        paginationPerPage={this.props.paginationPerPage}
        paginationTotalRows={this.props.totalCount}
        onChangeRowsPerPage={this.props.handlePerRowsChange}
        onChangePage={this.props.handlePageChange}
      />
    );
  }
}

export default ApplicationsTable;
